import { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'core/api'
import { Info } from '@material-ui/icons'

import Header from 'components/Header'
import RoundedButton from 'components/Button'
import RenderStepContent from './components/RenderStepContent'
import { RenderSuccessMessage } from './components/RenderSucessMessage'
import { RenderErrorMessage } from './components/RenderErrorMessage'
import { useAppContext } from 'App'
import download from 'core/functions/download.function'

import {
  DirectLinkImportContainer,
  ImportContainer,
  ImportSteps,
  ImportSingleStep,
  StepValue,
  StepLabel,
  CheckIcon,
  DescriptionBox,
  DescriptionTitle,
  DescriptionList,
  DescriptionItem,
  RequiredBadge,
  OptionalBadge
} from './style'
import { Typography } from '@material-ui/core'

function DirectLinkImport(props) {
  const { notify } = useAppContext()
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [campaignId, setCampaignId] = useState(0)
  const [campaigns, setCampaigns] = useState([])
  const [processCompleted, setProcessCompleted] = useState(false)
  const [error, setError] = useState(null)
  const [activeStep, setActiveStep] = useState(1)

  const excelModelLink =
    'https://yv-misc.s3.amazonaws.com/Modelo_Links_Identificados.xlsx'

  const steps = [
    { id: 1, label: 'Selecionar Campanha', completed: campaignId > 0 },
    { id: 2, label: 'Enviar Arquivo', completed: file !== null },
    { id: 3, label: 'Processar', completed: processCompleted }
  ]

  const handleStepClick = (stepId) => {
    if (stepId === 1 || (stepId === 2 && campaignId > 0)) {
      setActiveStep(stepId)
    }
  }

  useEffect(() => {
    axios
      .get('campaign/getall')
      .then((res) => setCampaigns(res.data))
      .catch((error) => {
        console.error('Erro ao carregar campanhas:', error)
      })
  }, [])

  const sendFile = () => {
    setError(null)
    axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    let fileData = new FormData()
    fileData.append('list', file)

    setLoading(true)

    axios({
      method: 'POST',
      url: 'directlink/generate?idCampaign=' + campaignId,
      responseType: 'blob',
      data: fileData
    })
      .then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'resultado.xlsx'
        link.click()

        setProcessCompleted(true)
      })
      .catch(async (error) => {
        let errorMessage = 'Erro desconhecido'

        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text()
            const json = JSON.parse(text)

            errorMessage = json.message || JSON.stringify(json)
          } catch (e) {
            errorMessage = error.message
          }
        } else {
          errorMessage = error.response?.data?.message || error.message
        }

        notify(errorMessage, 'error')
        setError(errorMessage)
      })
      .finally(() => {
        setLoading(false)
        axios.defaults.headers['Content-Type'] = 'application/json'
      })
  }

  const handleNewImport = () => {
    setFile(null)
    setError(null)
    setCampaignId(0)
    setProcessCompleted(false)
    setActiveStep(1)
  }

  const handleRetry = () => {
    setError(null)
    if (file && campaignId > 0) {
      sendFile()
    } else {
      setActiveStep(campaignId > 0 ? 2 : 1)
    }
  }

  const handleDownloadModel = () => download(excelModelLink)

  return (
    <DirectLinkImportContainer>
      <Header title="Links Identificados" />

      <DescriptionBox>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
          }}
        >
          <DescriptionTitle>
            <Info color="primary" />
            Formato da Planilha
          </DescriptionTitle>
          <RoundedButton
            onClick={handleDownloadModel}
            variant="contained"
            color="primary"
            size="small"
            text="Baixar modelo"
            type="download"
          />
        </div>
        <Typography variant="body2" gutterBottom>
          Envie uma planilha no formato .xlsx, .xls ou csv contendo os contatos
          e suas dimensões personalizadas.
        </Typography>

        <DescriptionList>
          <DescriptionItem>
            <RequiredBadge>Obrigatório</RequiredBadge>
            <div>
              <strong>1. Primeira coluna:</strong> Nome
              <br />
              <strong>2. Segunda coluna:</strong> E-mail ou Telefone
            </div>
          </DescriptionItem>

          <DescriptionItem>
            <OptionalBadge>Opcional</OptionalBadge>
            <div>
              <strong>Demais colunas:</strong> Dimensões extras que serão
              associadas ao contato
            </div>
          </DescriptionItem>
        </DescriptionList>

        <p>
          <strong>
            Após o upload, o sistema irá processar o arquivo e gerar uma URL
            personalizada para cada cliente.
          </strong>
        </p>
      </DescriptionBox>

      <ImportContainer>
        <ImportSteps>
          {steps.map((step) => (
            <ImportSingleStep
              key={step.id}
              active={activeStep === step.id}
              completed={step.completed}
              onClick={() => handleStepClick(step.id)}
            >
              <StepValue
                active={activeStep === step.id}
                completed={step.completed}
              >
                {step.completed ? <CheckIcon /> : step.id}
              </StepValue>
              <StepLabel
                active={activeStep === step.id}
                completed={step.completed}
              >
                {step.label}
              </StepLabel>
            </ImportSingleStep>
          ))}
        </ImportSteps>

        {processCompleted ? (
          RenderSuccessMessage(handleNewImport)
        ) : error ? (
          RenderErrorMessage(error, handleNewImport, handleRetry)
        ) : (
          <RenderStepContent
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            file={file}
            setFile={setFile}
            campaignId={campaignId}
            setCampaignId={setCampaignId}
            campaigns={campaigns}
            sendFile={sendFile}
            loading={loading}
            campaignAllSelected={props.campaignAllSelected}
          />
        )}
      </ImportContainer>
    </DirectLinkImportContainer>
  )
}

export default withTranslation()(DirectLinkImport)
